import { render } from "./GoToCheckout.vue?vue&type=template&id=68ecd4f2"
import script from "./GoToCheckout.vue?vue&type=script&lang=js"
export * from "./GoToCheckout.vue?vue&type=script&lang=js"

import "./GoToCheckout.vue?vue&type=style&index=0&id=68ecd4f2&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__